/**
 * Minimal module lifecycle for the theme's JS modules.
 *
 * Each module registered with app.use() is instantiated once the DOM is ready,
 * then boot() runs, and ready() runs with whatever boot() resolved to.
 */
export class Module {

    constructor(app) {
        this.app = app;
    }

    boot(app) {

    }

    ready(app) {

    }
}

export class Application {

    constructor(options = {}) {
        this.options = options;
        this.modules = [];
        this.isReady = document.readyState !== 'loading';

        if (!this.isReady) {
            document.addEventListener('DOMContentLoaded', () => {
                this.isReady = true;
                this.modules.forEach((ModuleClass) => this.boot(ModuleClass));
            });
        }
    }

    use(ModuleClass) {
        if (typeof ModuleClass !== 'function') {
            throw new Error('The module can only be a class.');
        }

        this.modules.push(ModuleClass);

        if (this.isReady) {
            this.boot(ModuleClass);
        }
    }

    boot(ModuleClass) {
        const module = new ModuleClass(this);

        Promise.resolve(typeof module.boot === 'function' ? module.boot(this) : true)
            .then((result) => {
                if (typeof module.ready === 'function') {
                    module.ready(this, result);
                }
            })
            .catch((reason) => {
                if (reason instanceof Error) {
                    console.error(reason);
                }
            });
    }
}
